import {
  deleteRedirectionUrl,
  getPersistedRedirectionUrl
} from "../../utils/local-storage/redirection";

export const useRedirectionHelpers = () => {
  /**
   * If there is a confirmed redirection stored after switching customer, return the
   * redirection query. Else, if there is an unconfirmed redirection stored, it means
   * the customer switching was aborted and the old redirection can be deleted.
   */
  const getRedirectToViewUrl = () => {
    const redirectionLocalStorageObject = getPersistedRedirectionUrl();

    if (
      redirectionLocalStorageObject.queryString.length > 0 &&
      redirectionLocalStorageObject.confirmed
    ) {
      return `/redirect?${redirectionLocalStorageObject.queryString}`;
    } else if (redirectionLocalStorageObject.queryString.length > 0) {
      deleteRedirectionUrl();
      return "";
    } else {
      return "";
    }
  };

  return {
    getRedirectToViewUrl
  };
};
